import Cher from '@cuvva/cher';
import ksuid from '@cuvva/ksuid';
import { put, select, take } from 'redux-saga/effects';

import { runLtmEstimate } from '..';
import { quoteActions } from '../actions';
import { InternalQuoteState } from '../types';
import { createEstimate } from '~lib/platform/ltm/store/actions';
import { CreateEstimateResponse } from '~lib/platform/ltm/types';
import { createTakeEverySagaSet, requestAndTake } from '~lib/shared/redux/sagas';
import { gatherClientContext } from '~website/helpers/client-context';
import { ApplicationState } from '~website/store';

const generateRequestId = () => ksuid.generate('opsnonce').toString();

export default createTakeEverySagaSet(runLtmEstimate.actions.request, function* runLtmEstimateSaga() {
	// wait for other stuff to actually load..
	if ((yield select((s: ApplicationState) => s.internal.quote.state.prefetch.user)) !== true)
		yield take(quoteActions.fetchUser.success);

	if ((yield select((s: ApplicationState) => s.internal.quote.state.prefetch.preferences)) !== true)
		yield take(quoteActions.fetchPreferences.success);

	const qState: InternalQuoteState = yield select((state: ApplicationState) => state.internal.quote);

	const startDate = qState.state.startDate ?? null;

	// SC: from a earlier discussion we want to give some sort of realistic price on estimates
	// and 1 year of NCB yield an average price between people who put >1 and who sets 0.
	const ncbYears = qState.state.ncb ?? 1;
	const voluntaryExcess = qState.state.voluntaryExcess ?? 0;
	const useClass = qState.state.useClass ?? 'sdpc';
	const smartPricing = qState.state.smartPricing ?? false;

	try {
		const userId: string = yield select((state: ApplicationState) => state.internal.auth.user.response);
		const createEstimateRequestId = generateRequestId();
		const vehicleId: string = yield select((s: ApplicationState) => s.internal.quote.state.vehicleId);
		const ncb = { durationMonths: ncbYears > 0 ? ncbYears * 12 : 0 };

		const estimateResponse: CreateEstimateResponse = yield requestAndTake(
			createEstimate.request({
				requestId: createEstimateRequestId,
				userId,
				vehicleId,
				reason: 'user_request',
				type: 'motor_long_term',

				ncb,
				useClass,
				voluntaryExcess,
				startDate,
				smartPricing,

				location: null, // GPS Location, not needed on web
				clientContext: gatherClientContext(),
			})
		);

		yield put(runLtmEstimate.actions.success(estimateResponse));
	} catch (error) {
		yield put(runLtmEstimate.actions.failure(Cher.coerce(error)));
	}
});
